import ReactMarkdown from 'react-markdown'

import { Button } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const StyledLogo = styled.img`
  margin-bottom: 40px;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 40px auto 25px;
    display: flex;
  }
`

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: ${style(theme => theme.colors.greenDark)};
  border-radius: ${style(theme => theme.borderRadius.large)};
  box-shadow: ${style(theme => theme.shadows.lgDark)};
  padding: 70px 70px 50px;

  @media screen and (min-width: ${style(theme => theme.breakpoints.sm + 1)}px) {
    width: 100%;
    box-shadow: ${style(theme => theme.shadows.lgMedium)};
  }
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    border-radius: 0px;
    padding: 0 0 14px 0;
  }
`

export const Content = styled.div`
  padding: 70px 70px 50px;
`

export const TextContainer = styled.div`
  padding: 0 10px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 0 30px;
    margin: 20px 0 0 0;
  }
`
export const StyledAddPortfolioButton = styled(Button)`
  width: 220px;
  margin: 30px 0 60px;
`
export const ValuePropContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 20px 0 30px;
  }
`

export const StyledValueProp = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`

export const ValuePropText = styled.p`
  margin: 0 0 0 16px;
  font-size: 16px;
  line-height: 24px;
  color: ${style(theme => theme.colors.white)};
  flex: 1;
`

export const Title = styled.h1`
  font-size: 40px;
  line-height: 55px;
  color: ${style(theme => theme.colors.white)};
  margin: 0;
`

export const BodyHeader = styled.h1`
  font-size: 22px;
  line-height: 30px;
  margin: 0 auto 20px;
  color: ${style(theme => theme.colors.white)};
`

export const Body = styled.div`
  white-space: pre-wrap;
  color: ${style(theme => theme.colors.white)};
  font-size: 14px;
  line-height: 22px;
  &:not(:last-child) {
    margin-bottom: 50px;
  }
  > a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: inherit;
  }
`

export const CenteredContainer = styled.div<{ isLoading?: boolean }>`
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 650px;
  max-width: 800px;
  background: ${style(theme => theme.colors.white)};
  border-radius: ${style(theme => theme.borderRadius.large)};
  box-shadow: ${style(theme => theme.shadows.lgDark)};
  position: relative;

  ${props =>
    props.isLoading &&
    `
    > div {
      margin: 0;
    }
  `}

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: -20px -20px 0;
    border-radius: 0px;
    padding: 0;
    height: calc(100vh - 70px);
    box-shadow: none;
  }
`

export const LoadingTitle = styled.h1`
  font-size: 16px;
  line-height: 24px;
  margin: 30px auto 0;
  color: ${style(theme => theme.colors.slate)};
  font-weight: 600;
`

export const MarkdownStyler = styled.span`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 5px;
  display: inline-block;
`

export const SuccessMarkdownStyler = styled.span`
  font-size: 22px;
  line-height: 30px;
  font-weight: 600;
  display: inline-block;
`

export const SuccessTextContainer = styled.div`
  max-width: 400px;
  margin: 30px auto 0;
  text-align: center;

  span:first-of-type {
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 0 30px;
  }
`

export const SuccessBody = styled.p`
  margin-top: 10px;
  font-size: 14px;
  line-height: 22px;
`

export const SuccessButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-top: 1px solid ${style(theme => theme.colors.ivory)};
  width: 100%;
  padding: 30px;

  > .add-crypto-success-button {
    width: 220px;
    margin: 0 auto;
  }
`

export const SuccessSecondaryButton = styled.button`
  display: flex;
  margin: 10px auto 0;
  width: 220px;
  background: ${style(theme => theme.colors.white)};
  color: ${style(theme => theme.colors.stone)};
  font-size: 14px;
  border: none;
  padding: 6px;
  justify-content: center;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
`

export const MobileButtonContainer = styled.div`
  display: flex;
  bottom: 0;
  flex-direction: column;
  width: 100%;
  position: sticky;
`

export const StyledMarkdown = styled(ReactMarkdown)`
  > p {
    font-size: 12px;
    line-height: 16px;
    margin: 20px 0 0;
  }
`
